import styled, { keyframes } from 'styled-components';

const zoomIn = keyframes`
  0% {
    opacity: 0;
    display: block;
    transform: scale(0.9, 0.9); 
  }
  100% {
    opacity: 1;
    display: block;
    transform: scale(1.0, 1.0);
  }
`;

const zoomOut = keyframes`
  0% {
    opacity: 1;
    transform: scale(1.0, 1.0); 
  }
  100% {
    opacity: 0;
    transform: scale(0.9, 0.9);
  }
`;

export const SnackContain = styled.div`
  position: fixed;
  bottom: 48px;
  right: calc(50% - 240px);
  min-width: 480px;

  ${(props) => props.theme.media.sm.max`
    bottom: 0px;
  `}
`;

export const Contain = styled.div`
  height: 100%;
`;

export const MessageContain = styled.div`
  padding: 16px;
  display: flex;
  border-radius: 4px;
  align-items: center;
  background-color: ${(props) => props.theme.brandColor};
  justify-content: center;
  box-shadow: 0 13px 27px -5px rgba(50, 50, 93, 0.25),
    0 8px 16px -8px rgba(0, 0, 0, 0.3);

  animation-duration: 0.4s;
  animation-name: ${(props) => (props.isOpen ? zoomIn : zoomOut)};
  animation-fill-mode: forwards;
  animation-timing-function: ease;
`;
